import parse from "html-react-parser";
import React from "react";

export const TOURNAMENT_TYPE = {
  MANUAL: "MANUAL",
  AUTOMATED: "AUTOMATED",
};

export const TAILORED_CONTENT_TYPE = {
  LEARNING_POINTS: "LEARNING_POINTS",
  PREVELANCE: "PREVELANCE",
};

export const TOURNAMENT_STATE = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISH",
};

export const allowedExtensions = [
  "jpeg",
  "jpg",
  "png",
  "gif",
  "mp4",
  "pdf",
  "psd",
  "ai",
  "doc",
  "docx",
  "ppt",
  "pptx",
  "csv",
  "xls",
  "xlsx",
];
export const allowedMimeTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "video/mp4",
  "application/pdf",
  "application/postscript", // for psd and ai files
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const roleOptions = [
  { code: "CL", text: "Clinical User" },
  { code: "NC", text: "Non-Clinical User" },
];
export const userRoles = [
  { code: "CL", text: "Clinical User" },
  { code: "CL-SC", text: "Speciality Cardiology" },
  { code: "CL-SN", text: "Speciality Nephrology" },
  { code: "CL-SO", text: "Oncology" },
  { code: "CL-SP", text: "Pulmonary" },
  { code: "CL-SB", text: "Neurology" },
  { code: "CL-SG", text: "Gastroenterology" },
  { code: "CL-SD", text: "Dermatology" },
  { code: "CL-IN", text: "Inpatient Specific Content" },
  { code: "NC", text: "Non-Clinical User" },
  { code: "NC-C", text: "Non Clinical Coder" },
  { code: "NC-CP", text: "Non Clinical Chart Prep" },
  { code: "NC-MA", text: "Non Clinical Medical Assistant" },
  { code: "CL-PED", text: "PED" },
  { code: "CL-SPECIALIST-BC", text: "Specialist-BC" },
  { code: "CL-HOSPITALISTS", text: "Hospitalists" },
  { code: "CL-SURGICAL", text: "Surgical" },
  { code: "CL-SBC", text: "SBC" },
  { code: "CL-ENDO", text: "Endocrinology" },
  { code: "CL-ENT", text: "ENT" },
  { code: "CL-OB", text: "OB" },
  { code: "CL-PSY", text: "Psychiatry" },
  { code: "CL-OPTHO", text: "Optho" },
  { code: "SP", text: "Specialist" },
];
export const userRolesMap = {
  CL: "Clinical User",
  "CL-SC": "Speciality Cardiology",
  "CL-SN": "Speciality Nephrology",
  "CL-SO": "Oncology",
  "CL-SP": "Pulmonary",
  "CL-SB": "Neurology",
  "CL-SG": "Gastroenterology",
  "CL-SD": "Dermatology",
  "CL-IN": "Inpatient Specific Content",
  NC: "Non-Clinical User",
  "NC-C": "Non Clinical Coder",
  "NC-CP": "Non Clinical Chart Prep",
  "NC-MA": "Non Clinical Medical Assistant",
  "CL-SPECIALIST-BC": "Specialist-BC",
  "CL-HOSPITALISTS": "Hospitalists",
  "CL-SURGICAL": "Surgical",
  "CL-SBC": "SBC",
  "CL-PED": "PED",
  "CL-ENDO": "Endocrinology",
  "CL-ENT": "ENT",
  "CL-OB": "OB",
  "CL-PSY": "Psychiatry",
  "CL-OPTHO": "Optho",
  SP: "Specialist",
};

export const userDesignations = [
  { code: "Admin", text: "Admin" },
  { code: "CN", text: "CN" },
  { code: "PA", text: "PA" },
  { code: "MD", text: "MD" },
  { code: "DO", text: "DO" },
  { code: "NP", text: "NP" },
  { code: "FNP", text: "FNP" },
  { code: "DNP", text: "DNP" },
  { code: "CIS", text: "CIS" },
  { code: "APRN", text: "APRN" },
  { code: "APN", text: "APN" },
  { code: "RN", text: "RN" },
  { code: "PA-C", text: "PA-C" },
  { code: "MSN", text: "MSN" },
  { code: "FNP-BC", text: "FNP-BC" },
  { code: "PSYCH", text: "Psych" },
  { code: "PED", text: "Ped" },
  { code: "EDD", text: "Edd" },
  { code: "PhD", text: "PhD" },
  { code: "LICSW", text: "LICSW" },
  { code: "LMHC", text: "LMHC" },
  { code: "PsyD", text: "PsyD" },
  { code: "CNM", text: "CNM" },
  { code: "LMFT", text: "LMFT" },
  { code: "PNP", text: "PNP" },
  { code: "FNP-C", text: "FNP-C" },
  { code: "PCNS", text: "PCNS" },
  { code: "DMD", text: "DMD" },
  { code: "CPNP", text: "CPNP" },
  { code: "OD", text: "OD" },
];

export const nonClinicalUserRoles = [
  { code: "NC", text: "Non-Clinical User" },
  { code: "NC-C", text: "Non Clinical Coder" },
  { code: "NC-CP", text: "Non Clinical Chart Prep" },
];
export const userTypes = [
  { code: 0, text: "Free" },
  { code: 2, text: "Premium" },
  { code: 3, text: "Demo" },
  { code: 4, text: "Enterprise" },
  { code: 5, text: "Enterprise Lite" },
  { code: 6, text: "Enterprise Admin" },
];
export const userTypesMap = {
  0: "Free User",
  1: "Requested for Purchase",
  2: "Premium User",
  3: "Demo",
  4: "Enterprise",
  5: "Enterprise Lite",
  6: "Enterprise Admin",
};

export const userSectionUserTypesMap = {
  3: "Demo",
  4: "Enterprise",
  6: "Enterprise Admin",
};

export const typePostMap = {
  Video: "VIDEO",
  Article: "ARTICLE",
  Pearls: "PEARL",
  Tips: "TIP",
};
export const moduleTypes = [
  { code: "SM", text: "Self Assessment" },
  { code: "TM", text: "Training Module" },
  { code: "CM", text: "Certification" },
  { code: "WM", text: "Contests" },
];
export const billingLicenseTypes = [
  { code: "CL", text: "Clinical Licenses" },
  { code: "NC", text: "Non-Clinical Licenses" },
  { code: "CL_SPECIALIST", text: "Specialist" },
];
export const licenseRoles = {
  CL: "Clinical Licenses",
  NC: "Non-Clinical Licenses",
  CL_SPECIALIST: "Specialist",
};

export const DOCTOR_ROLES = {
  CL: "Clinical User",
  NC: "Non-Clinical User",
  SP: "Specialist",
};

// Add sub-type role mapping
export const SUB_ROLE_MAPPING = {
  CL: [
    { code: "CL", text: "Clinical User" },
    { code: "CL-SC", text: "Speciality Cardiology" },
    { code: "CL-SN", text: "Speciality Nephrology" },
    { code: "CL-SO", text: "Oncology" },
    { code: "CL-SP", text: "Pulmonary" },
    { code: "CL-SB", text: "Neurology" },
    { code: "CL-SG", text: "Gastroenterology" },
    { code: "CL-SD", text: "Dermatology" },
    { code: "CL-IN", text: "Inpatient Specific Content" },
    { code: "CL-SBC", text: "SBC" },
    { code: "CL-HOSPITALISTS", text: "Hospitalists" },
    { code: "CL-SURGICAL", text: "Surgical" },
  ],
  NC: [
    { code: "NC", text: "Non-Clinical User" },
    { code: "NC-C", text: "Non Clinical Coder" },
    { code: "NC-CP", text: "Non Clinical Chart Prep" },
  ],
  SP: [
    { code: "SP", text: "Specialist" },
    { code: "CL-SPECIALIST-BC", text: "Specialist-BC" },
  ],
};

export const V28_COMPATIBILITY = [
  { code: "YES", text: "Yes, No Action Needed" },
  { code: "NO", text: "No - HCC Removed" },
  { code: "NEED_EDITS", text: "Needs Edits" },
  { code: "FUTURE_REVIEW", text: "Further Review" },
];

export const V28_COMPATIBILITY_MAP = {
  YES: "Yes, No Action Needed",
  NO: "No - HCC Removed",
  NEED_EDITS: "Needs Edits",
  FUTURE_REVIEW: "Further Review",
};

export const programQuestionStatusTxt = [
  { code: "READY", text: "Ready" },
  { code: "INUSE", text: "In Use" },
  { code: "EXPIRED", text: "Expired" },
];

export const ACTIVE_QUESTION_STATUS = {
  READY: "Ready",
  INUSE: "In Use",
};

export const programQuestionTypes = {
  SC: "Single Choice",
  BC: "Boolean Choices",
  MC: "Multiple Choices",
};

export const lastAssignedDateOptions = {
  current_month: "Current Month",
  last_month: "Last Month",
  current_quarter: "Current Quarter",
  last_quarter: "Last Quarter",
  current_year: "This Year",
};

export const contestType = {
  WEEKLY: "Weekly",
  BI_WEEKLY: "Bi-Weekly",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
  CUSTOM: "Custom",
};

export const cadanceTypes = {
  WEEKLY: "Weekly",
  MONTHLY: "Monthly",
  QUARTERLY: "Quarterly",
};

export const assignmentTypes = {
  ORG: "Organization",
  GROUP: "User Group",
  CLINIC: "Clinic",
};

export const tailoredFrequencyTypes = {
  true: "Yes",
  false: "No",
};

export const timeZones = {
  IST: "IST",
  UTC: "UTC",
  PST: "PST",
  EST: "EST",
  CST: "CST",
  MST: "MST",
};

export const timeZoneMap = {
  IST: "Asia/Kolkata",
  UTC: "UTC",
  PST: "America/Los_Angeles",
  EST: "America/New_York",
  CST: "America/Chicago",
  MST: "America/Denver",
};

export const programQuestionUploadEditAllowed = ["READY", "INUSE"];

export const complexityList = ["BEGINNER", "INTERMEDIATE", "ADVANCED"];
export const programQuestionStatusList = ["READY", "INUSE", "EXPIRED"];
export const feedContentType = ["FREE", "PREMIUM"];
export const designationsList = [
  "Admin",
  "CN",
  "PA",
  "MD",
  "DO",
  "NP",
  "FNP",
  "DNP",
  "CIS",
  "APRN",
  "None",
];
export const userCountryCodes = [
  {
    name: "United States / Canada",
    dial_code: "+1",
    code: "US",
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
  },
];
export const tablePageSizeOptions = [10, 15, 25];

export const validateEmail = (email) => {
  const regex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

export const filterResetUrlExceptions = [
  /^\/programs\/questions$/,
  /^\/tournaments\/list$/,
];

export const getCodeText = (type, code) => {
  let codeTxt = code;
  if (type === "role") {
    userRoles.forEach(function (roleEntry) {
      if (roleEntry.code === code) {
        codeTxt = roleEntry.text;
      }
    });
  } else if (type === "userCountryCode") {
    userCountryCodes.forEach(function (countryCode) {
      if (countryCode.dial_code === code) {
        codeTxt = countryCode.name;
      }
    });
  } else if (type === "userType") {
    userTypes.forEach(function (typeEntry) {
      if (typeEntry.code === code) {
        codeTxt = typeEntry.text;
      }
    });
  } else if (type === "moduleType") {
    moduleTypes.forEach(function (moduleEntry) {
      if (moduleEntry.code === code) {
        codeTxt = moduleEntry.text;
      }
    });
  } else if (type === "billingLicenseType") {
    billingLicenseTypes.forEach(function (data) {
      if (data.code === code) {
        codeTxt = data.text;
      }
    });
  } else if (type === "userDesignation") {
    userDesignations.forEach(function (data) {
      if (data.code === code) {
        codeTxt = data.text;
      }
    });
  } else if (type === "programQuesStatus") {
    programQuestionStatusTxt.forEach(function (data) {
      if (data.code === code) {
        codeTxt = data.text;
      }
    });
  }

  return codeTxt;
};

export const getTextCode = (type, text) => {
  let textCode = text;
  if (type === "billingLicenseType") {
    billingLicenseTypes.forEach(function (data) {
      if (data.text === text) {
        textCode = data.code;
      }
    });
  }
  return textCode;
};

export const getSelectedListTxt = (type, array) => {
  const txtArr = [];
  if (type === "userType") {
    array.forEach(function (selItem) {
      txtArr.push(getCodeText("userType", selItem));
    });
  } else if (type === "moduleType") {
    array.forEach(function (selItem) {
      txtArr.push(getCodeText("moduleType", selItem));
    });
  } else if (type === "programQuesStatus") {
    array.forEach(function (selItem) {
      txtArr.push(getCodeText("programQuesStatus", selItem));
    });
  } else if (type === "role") {
    array.forEach(function (selItem) {
      txtArr.push(getCodeText("role", selItem));
    });
  }
  return txtArr.join(", ");
};

export const isJSONString = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const nFormatter = (num, digits) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    .slice()
    .reverse()
    .find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};

export const formatObjectToString = (obj) => {
  let resultString = "";
  for (const [key, valueArray] of Object.entries(obj)) {
    // Assuming each key has an array with exactly one string element
    const value = valueArray[0]; // Get the first item from the array
    resultString += `${key}: ${value}`;
  }
  const colonCount = resultString.split(":").length - 1;
  if (colonCount > 5) {
    resultString = "Something went wrong. Please try later.";
  }
  return resultString;
};

export const formatObjectToStringWithJustValue = (obj) => {
  let resultString = "";
  for (const [_, valueArray] of Object.entries(obj)) {
    // Assuming each key has an array with exactly one string element
    const value = valueArray; // Get the first item from the array
    if (value && value.length > 0) {
      resultString += `${value.join(", ")}`;
    } else {
      resultString = "";
    }
  }
  return resultString;
};

export const formatDatetoString = (type = "type1", dateString) => {
  const date = new Date(dateString);

  // Extract components using UTC methods
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1; // getUTCMonth returns 0-11
  const day = date.getUTCDate();
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();

  // Convert 24-hour time to 12-hour format with AM/PM
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  // Types:
  // "type1" - MM/dd/yyyy '|' hh:mm a
  // "type2" - YYYY-MM-DD

  // Format date manually or use a helper function to pad single digits
  let formattedDate = `${month.toString().padStart(2, "0")}/${day.toString().padStart(2, "0")}/${year} | ${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")} ${ampm}`;
  // Default format is MM/dd/yyyy '|' hh:mm a
  if (type === "type2") {
    formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
  }
  return formattedDate;
};

// Regular expression to match URLs starting with http, https, or www
const urlRegex =
  /(\bhttps?:\/\/[^\s/$.?#].[^\s]*)|(\bwww\.[^\s/$.?#].[^\s]*)/gi;

// Function to format text and wrap URLs with anchor tags
// Function to wrap URLs with <a> tags
const wrapUrlsWithLinks = (text) => {
  const parts = text.split(urlRegex);

  return parts.map((part, index) => {
    // Check if the part matches a URL
    if (urlRegex.test(part)) {
      const href = part.startsWith("http") ? part : `https://${part}`; // Prepend http:// to 'www.' links
      return (
        <a
          key={index}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2abdf0", textDecoration: "underline" }}>
          {part}
        </a>
      );
    }
    // Return non-URL parts as plain text
    return part;
  });
};

// Function to format text and wrap URLs with anchor tags (handling both HTML and plain text)
export const formatTextWithLinks = (htmlOrPlainText) => {
  // Check if the input contains any HTML tags (basic heuristic)
  const containsHtmlTags = /<\/?[a-z][\s\S]*>/i.test(htmlOrPlainText);

  // If the input contains HTML, use html-react-parser to parse it
  if (containsHtmlTags) {
    return parse(htmlOrPlainText, {
      replace: (domNode) => {
        // Process only text nodes
        if (domNode.type === "text") {
          return <>{wrapUrlsWithLinks(domNode.data)}</>;
        }
        // Return other node types as they are (HTML elements)
        return domNode;
      },
    });
  }

  // If the input is plain text, directly return wrapped URLs
  return <>{wrapUrlsWithLinks(htmlOrPlainText)}</>;
};

export const IANATimezones = {
  IST: "Asia/Kolkata",
  UTC: "UTC",
  PST: "America/Los_Angeles",
  EST: "America/New_York",
  CST: "America/Chicago",
  MST: "America/Denver",
};

export const profileImageAllowedExtensions = ["jpg", "jpeg", "png", "webp"];
export const profileImageAllowedMimeTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
];
